/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */
import isType from './is-type';
export default (function (value) {
  return isType(value, 'Function');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-function.js
// module id = 3
// module chunks = 0